import type {
  ConversationsItemApiRepsonse,
  SuggestionQuery,
  IntroQuery,
  AskQuery,
  AgentItemApiResponse,
  AgentItemsApiResponse,
  SuggestionItemApi,
  IntroItemApi,
  PatientConversationQuery,
  AgentRatingApiQuery,
} from "@/Modules/Agent/Models/Api";

import { get2, patch2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export async function getConversations(): Promise<ConversationsItemApiRepsonse> {
  return get2<void, ConversationsItemApiRepsonse>(`/v1.0/rag/conversations`, undefined, undefined, {
    raw: true,
  });
}

export async function getConversation(customerUuid: string): Promise<AgentItemsApiResponse> {
  return get2<void, AgentItemsApiResponse>(`/v1.0/rag/conversations/${customerUuid}`, undefined, undefined, {
    raw: true,
  });
}

export async function getUserConversations(customerUuid: string): Promise<ConversationsItemApiRepsonse> {
  return get2<PatientConversationQuery, ConversationsItemApiRepsonse>(
    "/v1.0/rag/conversations",
    {
      customer_uuid: customerUuid,
    },
    undefined,
    {
      raw: true,
    }
  );
}

export async function deleteConversation(customerUuid: string): Promise<AgentItemApiResponse[]> {
  return remove2<void, AgentItemApiResponse[]>(`/v1.0/rag/conversations/${customerUuid}`);
}

export async function getIntro(customerUuid: string): Promise<IntroItemApi> {
  return get2<IntroQuery, IntroItemApi>("/v1.0/rag/intro", {
    customer_uuid: customerUuid,
  });
}

export async function getSuggestions(customerUuid: string): Promise<SuggestionItemApi[]> {
  return get2<SuggestionQuery, SuggestionItemApi[]>("/v1.0/rag/buttons", {
    customer_uuid: customerUuid,
  });
}

export async function postAsk(customerUuid: string, question: string): Promise<AgentItemApiResponse> {
  return post2<AskQuery, AgentItemApiResponse>(
    `/v1.0/rag/conversations/${customerUuid}`,
    {
      question: question,
    },
    undefined,
    {
      raw: true,
    }
  );
}

export async function sendRating(
  uuid: string,
  ratingData: AgentRatingApiQuery
): Promise<AgentRatingApiQuery> {
  return await patch2<AgentRatingApiQuery, AgentRatingApiQuery>(`/v1.0/maia/ratings/${uuid}`, ratingData);
}

export async function deleteRating(uuid: string): Promise<AgentRatingApiQuery> {
  return await remove2<void, AgentRatingApiQuery>(`/v1.0/maia/ratings/${uuid}`);
}
